var map = {
	"./LOGO.png": 1537,
	"./about/advertisement_1.png": 6875,
	"./about/advertisement_2.png": 5664,
	"./about/advertisement_3.png": 9865,
	"./about/background.png": 6450,
	"./about/dash.png": 2930,
	"./about/dept_1.png": 2311,
	"./about/dept_2.png": 1823,
	"./about/dept_3.png": 7093,
	"./about/dept_4.png": 218,
	"./about/dept_5.png": 9075,
	"./about/partner_1.png": 2366,
	"./about/partner_2.png": 4165,
	"./about/partner_3.png": 4748,
	"./about/partner_4.png": 4707,
	"./about/partner_5.png": 9498,
	"./about/partner_6.png": 8481,
	"./about/partner_7.png": 3864,
	"./about/partner_8.png": 1343,
	"./about/to_left.png": 6737,
	"./about/to_right.png": 154,
	"./address.png": 7270,
	"./contact/address.png": 1875,
	"./contact/background.png": 3023,
	"./contact/icon_1.png": 6152,
	"./contact/icon_2.png": 643,
	"./contact/icon_3.png": 9882,
	"./contact/to_left.png": 8886,
	"./contact/to_right.png": 5435,
	"./dash.png": 1136,
	"./download/Intelligent_dialogue.png": 8765,
	"./download/android.png": 5204,
	"./download/android_qr.png": 1900,
	"./download/app.png": 9612,
	"./download/audio_transcription.png": 6486,
	"./download/background_1.png": 2505,
	"./download/background_2.png": 1794,
	"./download/icon_1.png": 6134,
	"./download/icon_2.png": 7757,
	"./download/icon_3.png": 7812,
	"./download/icon_4.png": 9467,
	"./download/icon_background.png": 9699,
	"./download/ios.png": 9918,
	"./download/ios_qr.png": 2898,
	"./download/scene_1.png": 2169,
	"./download/scene_2.png": 3986,
	"./download/scene_3.png": 5531,
	"./download/scene_4.png": 724,
	"./download/translation.png": 2152,
	"./email.png": 5738,
	"./home/ai_robot.png": 3537,
	"./home/background_1.png": 4630,
	"./home/background_2.png": 8605,
	"./home/background_3.png": 4708,
	"./home/background_4.png": 8571,
	"./home/business_1.png": 8648,
	"./home/business_2.png": 4403,
	"./home/business_3.png": 9194,
	"./home/business_4.png": 6069,
	"./home/left.png": 4017,
	"./home/meeting.png": 547,
	"./home/product_1.png": 7233,
	"./home/product_2.png": 6650,
	"./home/product_3.png": 1859,
	"./home/right.png": 4090,
	"./home/to_right.png": 5434,
	"./login/background.png": 9246,
	"./login/qr_code.png": 8427,
	"./login/wechat.png": 3212,
	"./news/background.png": 4202,
	"./news/more.png": 7253,
	"./news/new_1.png": 4538,
	"./news/new_2.png": 3521,
	"./news/new_3.png": 8904,
	"./news/new_4.png": 423,
	"./news/search.png": 5222,
	"./news/time.png": 9609,
	"./pay/alarm_clock.png": 3501,
	"./pay/alipay.png": 6883,
	"./pay/avatar.png": 7686,
	"./pay/background_2.png": 4002,
	"./pay/background_3.png": 5131,
	"./pay/crown.png": 288,
	"./pay/qr_code.png": 7754,
	"./pay/safety.png": 6775,
	"./pay/wechat.png": 1583,
	"./phone.png": 2978,
	"./products/AI_1.png": 9327,
	"./products/AI_2.png": 6868,
	"./products/AI_3.png": 7997,
	"./products/AI_4.png": 5202,
	"./products/app.png": 6472,
	"./products/background_1.png": 8669,
	"./products/background_2.png": 7430,
	"./products/icon_1.png": 4434,
	"./products/icon_2.png": 521,
	"./products/icon_3.png": 4272,
	"./products/left.png": 3734,
	"./products/product_1.png": 4448,
	"./products/product_2.png": 9851,
	"./products/product_3.png": 6194,
	"./products/product_4.png": 8989,
	"./products/product_5.png": 7860,
	"./products/product_6.png": 319,
	"./products/right.png": 8123,
	"./products/to_right.png": 4557,
	"./send.png": 8802,
	"./to_top.png": 2015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;